import { Box, Button, Grid, Typography } from "@mui/material";
import { MbTextField } from "../../../../../components/MbTextFields";
import { useUser } from "../../../../../contexts/user.context";
import { useForm } from "react-hook-form";
import { mobilizeiStoresService } from "../../../../../services/mobilizei/stores.service";
import { useState } from "react";
import CompanyAccountDialog from "../CompanyAccountDialog";
import _ from "lodash";
import useAppInfo from "../../../../../hooks/appInfo.hook";
import { storeStatus } from '../../../../../utils/constants';

export default function AccountContent({ blocked }) {
  const { user, setUser } = useUser();
  const { appInfo } = useAppInfo();

  const isDisabled = (appInfo?.storeStatus !== storeStatus.ACTIVE) || blocked;

  const [showCompanyAccountDialog, setShowCompanyAccountDialog] = useState(false);

  const { getValues, handleSubmit, register, formState: { errors } } = useForm({
    defaultValues: {
      teamName: user?.store?.platforms?.ios?.teamName,
      teamID: user?.store?.platforms?.ios?.teamID
    }
  });

  function onSubmit() {
    setShowCompanyAccountDialog(true)
  }

  function goToNextStep() {
    let data = getValues();

    if (data.teamName) {
      data.teamName = data.teamName.trim()
    }

    mobilizeiStoresService
      .updateStoreById(user?.store?.platformId, user?.store?.id, {
        platforms: {
          ios: {
            teamName: data.teamName,
            teamID: data.teamID
          }
        }
      }).catch(() => null)

    // Set the local user properties
    setUser({
      ...user,
      store: {
        ...user?.store,
        platforms: {
          ...user?.store?.platforms,
          ios: {
            ...user?.store?.platforms?.ios,
            teamName: data.teamName,
            teamID: data.teamID
          }
        }
      }
    })

    setShowCompanyAccountDialog(false)
  }

  return (
    <Box>
      {user?.store?.platforms?.ios?.teamID
        && user?.store?.platforms?.ios?.teamName
        ? (
          <Grid
            container
            display={'flex'}
            flexDirection={'column'}
            spacing={2}
          >
            <Grid item>
              <Typography variant="body1">
                ID de equipe da conta de desenvolvedor Apple: <strong style={{ color: '#3cd568' }}>
                  {user?.store?.platforms?.ios?.teamID}
                </strong>
              </Typography>
            </Grid>

            <Grid item>
              <Typography variant="body1">
                Nome da identidade da conta de desenvolvedor Apple: <strong style={{ color: '#3cd568' }}>
                  {user?.store?.platforms?.ios?.teamName}
                </strong>
              </Typography>
            </Grid>

          </Grid>

        )
        : (
          <Grid
            container
            component="form"
            display={'flex'}
            flexDirection={'column'}
            spacing={2}
            onSubmit={handleSubmit(onSubmit)}
          >

            <Grid item xs={12}>
              <Typography variant="body1" mb={2}>
                Para publicar a versão iOS do seu aplicativo, <strong> é necessário que você crie uma conta de desenvolver Apple do tipo "Empresarial" (Company / Organization)</strong>.
              </Typography>

              <Typography variant="body1" mb={2}>
                Essa conta tem um  <strong>custo anual de U$ 99 (noventa e nove dólares)</strong>, pagos diretamente a Apple.
              </Typography>

              <Typography variant="body1" mb={2}>
                Para facilitar esse processo, preparamos um tutorial completo:
                <a
                  href="https://mobilizei.com.br/tutoriais/como-criar-conta-desenvolvedor-apple"
                  target="_blank"> clique aqui para acessar</a>.
              </Typography>

              <Typography variant="subtitle1" mb={2}>
                Com sua conta criada, precisamos saber qual é o  <strong>"Nome da entidade"</strong> e o <strong>"ID de equipe"</strong> da sua conta de desenvolvedor. <a href="https://mobilizei.com.br/tutoriais/onde-encontrar-team-name-id-conta-apple" target="_blank">Clique aqui</a> para verificar onde você pode encontrar estas informações e as insira nos campos abaixo.
              </Typography>
            </Grid>

            <Grid item>
              <MbTextField
                error={errors.teamName?.message}
                label="Nome da entidade:"
                inputProps={{
                  placeholder: "Digite o nome da entidade da sua conta de desenvolvedor Apple",
                  disabled: isDisabled
                }}
                register={register('teamName', {
                  required: "Insira o nome da entidade da sua conta de desenvolvedor Apple para continuar."
                })}
              />

              <MbTextField
                error={errors.teamID?.message}
                label="ID de equipe:"
                inputProps={{
                  placeholder: "Digite o ID de equipe da sua conta de desenvolvedor Apple",
                  disabled: isDisabled
                }}
                register={register('teamID', {
                  required: "Insira o ID de equipe da sua conta de desenvolvedor Apple para continuar."
                })}
              />

              <Box display='flex' justifyContent='center' marginTop={4} width='100%'>
                <Button variant="contained" disabled={isDisabled} type="submit">
                  próximo passo
                </Button>
              </Box>

              {blocked &&
                <Box display='flex' justifyContent='center' marginTop={2} width='100%'>
                  <Typography variant="body1" fontWeight='bold' marginTop={1}>
                    Finalize a criação do seu número DUNS para continuar
                  </Typography>
                </Box>
              }
            </Grid>
          </Grid>
        )}

      <CompanyAccountDialog
        open={showCompanyAccountDialog}
        handleClose={() => setShowCompanyAccountDialog(false)}
        goToNextStep={goToNextStep}
      />
    </Box>
  )
}